/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TechnicianJobDetailModel } from '../models/TechnicianJobDetailModel';
import type { TechnicianJobLogModelPagedListData } from '../models/TechnicianJobLogModelPagedListData';
import type { TechnicianJobRepairLabourSubmitModel } from '../models/TechnicianJobRepairLabourSubmitModel';
import type { TechnicianJobRepairLabourSubmitShortModel } from '../models/TechnicianJobRepairLabourSubmitShortModel';
import type { TechnicianJobRepairLineCreationResponseModel } from '../models/TechnicianJobRepairLineCreationResponseModel';
import type { TechnicianJobRepairPartSubmitModel } from '../models/TechnicianJobRepairPartSubmitModel';
import type { TechnicianJobRepairPartSubmitShortModel } from '../models/TechnicianJobRepairPartSubmitShortModel';
import type { TechnicianJobSendEmailModel } from '../models/TechnicianJobSendEmailModel';
import type { TechnicianJobSentEmailModel } from '../models/TechnicianJobSentEmailModel';
import type { TechnicianJobSubmitModel } from '../models/TechnicianJobSubmitModel';
import type { TechnicianRepairConcernPartsWithPartRequestsModel } from '../models/TechnicianRepairConcernPartsWithPartRequestsModel';
import type { TechnicianStatusEnum } from '../models/TechnicianStatusEnum';
import type { TechnicianUserModel } from '../models/TechnicianUserModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TechnicianJobService {

  /**
   * @param page 
   * @param pageSize 
   * @param status
 *
 * 1 = Active
 *
 * 2 = Invoiced
   * @param dateFrom 
   * @param dateTo 
   * @param regNo 
   * @param technicianId 
   * @param branchId 
   * @returns TechnicianJobLogModelPagedListData Success
   * @throws ApiError
   */
  public static getTechnicianJob(
page?: number,
pageSize?: number,
status?: TechnicianStatusEnum,
dateFrom?: string,
dateTo?: string,
regNo?: string,
technicianId?: number,
branchId?: number,
): CancelablePromise<TechnicianJobLogModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job',
      query: {
        'Page': page,
        'PageSize': pageSize,
        'Status': status,
        'DateFrom': dateFrom,
        'DateTo': dateTo,
        'RegNo': regNo,
        'TechnicianId': technicianId,
        'BranchId': branchId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Created
   * @throws ApiError
   */
  public static postTechnicianJob(
requestBody?: TechnicianJobSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobSetAuthorize(
id: number,
requestBody?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/set-authorize/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJob(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putTechnicianJob(
id: number,
requestBody?: TechnicianJobSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/technician-job/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepair(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/repair/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param wip 
   * @param userId 
   * @param branchId 
   * @returns any Success
   * @throws ApiError
   */
  public static getTechnicianJobLookUp(
wip?: number,
userId?: number,
branchId: number = 1,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/look-up',
      query: {
        'wip': wip,
        'userId': userId,
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns TechnicianJobRepairLineCreationResponseModel Created
   * @throws ApiError
   */
  public static postTechnicianJobRepairLabour(
requestBody?: TechnicianJobRepairLabourSubmitModel,
): CancelablePromise<TechnicianJobRepairLineCreationResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/repair-labour',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobRepairLabour1(
id: number,
requestBody?: TechnicianJobRepairLabourSubmitShortModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/repair-labour',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepairLabour(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}/repair-labour',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns TechnicianJobRepairLineCreationResponseModel Created
   * @throws ApiError
   */
  public static postTechnicianJobRepairPart(
requestBody?: TechnicianJobRepairPartSubmitModel,
): CancelablePromise<TechnicianJobRepairLineCreationResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/repair-part',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobRepairPart1(
id: number,
requestBody?: TechnicianJobRepairPartSubmitShortModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/repair-part',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobRepairPart(
id: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/{id}/repair-part',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postTechnicianJobDocuments(
id: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/documents',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param guid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobDocuments(
guid?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/documents',
      query: {
        'guid': guid,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns string Success
   * @throws ApiError
   */
  public static postTechnicianJobPhotos(
id: number,
formData?: {
userId?: number;
files?: Array<Blob>;
},
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/photos',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param photoGuid 
   * @returns boolean Success
   * @throws ApiError
   */
  public static deleteTechnicianJobPhotos(
photoGuid?: string,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/technician-job/photos',
      query: {
        'photoGuid': photoGuid,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param soHeaderId 
   * @param email 
   * @param subject 
   * @param body 
   * @returns TechnicianJobSendEmailModel Success
   * @throws ApiError
   */
  public static getTechnicianJobEmailBody(
id: number,
soHeaderId?: number,
email?: string,
subject?: string,
body?: string,
): CancelablePromise<TechnicianJobSendEmailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/email-body',
      path: {
        'id': id,
      },
      query: {
        'SoHeaderId': soHeaderId,
        'Email': email,
        'Subject': subject,
        'Body': body,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobEmail(
id: number,
requestBody?: TechnicianJobSentEmailModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/email',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param soHeaderId 
   * @param userId 
   * @param id 
   * @returns TechnicianJobDetailModel Success
   * @throws ApiError
   */
  public static getTechnicianJobJobDetails(
soHeaderId?: number,
userId?: number,
id?: number,
): CancelablePromise<TechnicianJobDetailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/job-details',
      query: {
        'soHeaderId': soHeaderId,
        'userId': userId,
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns TechnicianUserModel Success
   * @throws ApiError
   */
  public static getTechnicianJobTechUsers(): CancelablePromise<Array<TechnicianUserModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/tech-users',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postTechnicianJobCreateQuoteLaboursFromTechnicianJob(
id: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/technician-job/{id}/create-quote-labours-from-technician-job',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns TechnicianRepairConcernPartsWithPartRequestsModel Success
   * @throws ApiError
   */
  public static getTechnicianJobTechnicianRepairsPartsWithPartRequests(
id: number,
): CancelablePromise<Array<TechnicianRepairConcernPartsWithPartRequestsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/technician-job/{id}/technician-repairs-parts-with-part-requests',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

}
